import { Role } from '@common/application/enums/Role';

export const getAvailableRoles = (role: Role) => {
  const roles = [Role.SuperAdmin, Role.Admin, Role.SuperUser, Role.User];
  const roleIndex = roles.indexOf(role);
  return roles.slice(roleIndex);
};

export default getAvailableRoles;
